var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ce-accordion"},[_c('div',{staticClass:"toggler",on:{"click":_vm.toggleAccordion}},[_c('h3',[_vm._v(_vm._s(_vm.objectdata.mooHeadline))])]),_c('div',{staticClass:"accordion"},[_c('p',{domProps:{"innerHTML":_vm._f("replaceAmp")(_vm._f("replaceNbsp")(_vm.objectdata.text))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }